import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useEffect, useState } from "react";
import { Spinner } from "../Loading/Spinner";

export default function TableLogs({ data, limit }) {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    if (data && data.length > 0) {
      handleRows();
    }
    setIsLoading(false);
  }, [data]);

  const handleRows = () => {
    data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    setRows(data.map((d) => ({ action: d.action, lastAccess: d.createdAt })));
  };

  return (
    <>
      {isLoading && <Spinner />}
      {!isLoading && (
        <Box sx={{ position: "relative", textAlign: "center", p: 3 }}>
          <TableContainer component={Paper}>
            <Table
              sx={{ width: "100%" }}
              size="small"
              aria-label="a dense table"
            >
              <TableHead>
                <TableRow sx={{ backgroundColor: "gray", color: "white" }}>
                  <TableCell align="right" sx={{ color: "white" }}>
                    N° sesión
                  </TableCell>
                  <TableCell align="right" sx={{ color: "white" }}>
                    Evento
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{ color: "white" }}
                  >{`Últimos ${limit} accesos`}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                      backgroundColor: "lightgray",
                    }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{ color: "black" }}
                    >
                      {index + 1}
                    </TableCell>
                    <TableCell align="right" sx={{ color: "black" }}>
                      {row.action == "LOGIN_SUCCESSFUL"
                        ? "Inicio de sesión"
                        : ""}
                    </TableCell>
                    <TableCell align="right" sx={{ color: "black" }}>
                      {new Date(row.lastAccess).toLocaleString()}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </>
  );
}
